import { axios as client } from './apiAdmin'
import { exportFile } from '../requestDownloadFile'
export const financeApi = {
  // 获取商家近 30 天的广告活动聚合报表
  getFinanceSellerBillings: data => {
    return client.get('finance/seller/billings', { params: data }).then(res => res.data)
  },
  getFinanceSellerBillingsAgg: data => {
    return client.get('finance/seller/billings/agg', { params: data }).then(res => res.data)
  },
  financeSellerBillingsConfirm: data => {
    return client.post('finance/seller/billings/confirm', data).then(res => res.data)
  },
  financeSellerBillingsConfirmReview: data => {
    return client.post('finance/seller/billings/confirm-review', { params: data }).then(res => res.data)
  },
  getFinanceSellerBillingsDetailsList: data => {
    return client.get('finance/seller/billings/details', { params: data }).then(res => res.data)
  },
  getFinanceSellerDetailInfo: data => {
    return client.get(`finance/seller/billings/${data.id}`).then(res => res.data)
  },
  getFinanceSellerBillingsDetailsPendingReview: data => {
    return client.get('finance/seller/billings/details/pending-review', { params: data }).then(res => res.data)
  },
  financeSellerBillingsDetailsConfirmPayment: data => {
    return client.post('finance/seller/billings/details/confirm-payment', data).then(res => res.data)
  },
  downloadSellerPaymentConfirmTemplateFile: (data) => {
    return exportFile('finance/seller/billings/details/download-payment-confirm-template-file', data.qs, data.fileName, data.platform)
  },
  updaloadSellerPaymentConfirmFile: data => {
    return client.post('finance/seller/billings/details/upload-payment-confirm-file', data).then(res => res.data)
  },
  updaloadSellerBillingsDetailsConfirmBulkPayment: data => {
    return client.post('finance/seller/billings/details/confirm-bulk-payment', data).then(res => res.data)
  },
  getFinanceSellerBillingInvoice: data => {
    return client.get('finance/seller/billings/details/invoice', { params: data }).then(res => res.data)
  },
  getFinancePublisherBillingInvoice: data => {
    return client.get('finance/publisher/billings/invoice', { params: data }).then(res => res.data)
  },
  financeSellerBillingsDetailsNotifyEmail: data => {
    return client.post('finance/seller/billings/details/notify-email', data).then(res => res.data)
  },
  financeSellerBillingsDetailsNotifyEmailToAll: data => {
    return client.post('finance/seller/billings/notify-email-to-all', data).then(res => res.data)
  },

  getFinancePublisherBillingsAgg: data => {
    return client.get('finance/publisher/billings/agg', { params: data }).then(res => res.data)
  },
  getFinancePublisherBillings: data => {
    return client.get('finance/publisher/billings', { params: data }).then(res => res.data)
  },
  getFinancePublisherBillingsDetailsList: data => {
    return client.get('finance/publisher/billings/details', { params: data }).then(res => res.data)
  },
  getFinancePublisherDetailInfo: data => {
    return client.get(`finance/publisher/billings/${data.id}`).then(res => res.data)
  },
  getFinancePublisherBillingsDetailsPendingEdit: data => {
    return client.get('finance/publisher/billings/details/pending-edit', { params: data }).then(res => res.data)
  },
  financePublisherBillingsDetailsConfirmToPay: data => {
    return client.post('finance/publisher/billings/details/confirm-to-pay', data).then(res => res.data)
  },
  financePublisherBillingsConfirm: data => {
    return client.post('finance/publisher/billings/confirm', data).then(res => res.data)
  },
  getFinancePublisherBillingsDetailsPaymentHistory: data => {
    return client.get('finance/publisher/billings/details/payment-history', { params: data }).then(res => res.data)
  },

  getFinancePulisherBillingsDetailsBillingIdItems: data => {
    return client.get(`finance/publisher/billings/details/${data.billingId}/items`, { params: data }).then(res => res.data)
  },
  financePulisherBillingsDetailsBillingIdItemsExport: (data) => {
    return exportFile(`finance/publisher/billings/details/${data.billingId}/items/export`, data.qs, data.fileName, data.platform)
  },
  getFinanceSellerBillingsDetailsBillingIdItems: data => {
    return client.get(`finance/seller/billings/details/${data.billingId}/items`, { params: data }).then(res => res.data)
  },
  financeSellerBillingsDetailsBillingIdItemsExport: (data) => {
    return exportFile(`finance/seller/billings/details/${data.qs.billingId}/items/export`, data.qs, data.fileName, data.platform)
  },
  getFinanceARagingReport: data => {
    return client.get(`finance/ar/aging-report`, { params: data }).then(res => res.data)
  },
  sellerExportARagingReport: data => {//导出seller
    return exportFile(`finance/ar/aging-report/export`, data.qs, data.fileName, data.platform)
  },
  getFinanceARagingReportSellerMonthly: data => {
    return client.get(`finance/ar/aging-report/seller-monthly`, { params: data }).then(res => res.data)
  },
  sellerExportARagingReportSellerMonthly: data => {//导出seller
    return exportFile(`finance/ar/aging-report/seller-monthly/export`, data.qs, data.fileName, data.platform)
  },
  downloadProductDealTemplateFile: (data) => {
    return exportFile(`product/deal/template/download`, data.qs, data.fileName, data.platform)
  },
  productDealUpload: data => {
    return client.post(`product/deal/upload`, data).then(res => res)
  },
  dmSubmittedDealsManualCsvValidate: data => {
    return client.post(`dm-submitted-deals/manual/csv/validate`, data).then(res => res)
  },
  exportSellerPaymentConfirmDetail: (data) => {
    return exportFile(`finance/seller/billings/details/${data.qs.billingId}/items/export`, data.qs, data.fileName, data.platform)
  },
  financeSellerBillingsReportExport: (data) => {
    return exportFile(`finance/seller/billings/report/export`, data.qs, data.fileName, data.platform)
  },
  getFinancePlacementReview: data => {
    return client.get(`placement/list`, { params: data }).then(res => res.data)
  },
  getFinancePlacementCount: data => {
    return client.get(`placement/count`, { params: data }).then(res => res.data)
  },
  placementApprove: id => {
    return client.post(`placement/${id}/approve`).then(res => res.data)
  },
  placementReject: data => {
    return client.post(`placement/${data.id}/reject`, data).then(res => res.data)
  },
  campaignsList: data => {
    return client.get(`placement/campaigns/list`, { params: data }).then(res => res.data)
  },
  campaignsDetail: data => {
    return client.get(`placement/campaigns/${data.campaignId}/detail`, { params: data }).then(res => res.data)
  },
  campaignsPayment: data => {
    return client.post(`placement/campaigns/${data.campaignId}/payment`, data).then(res => res.data)
  },
  // 手动调整
  manualAdjustments: data => {
    return client.get(`finance/manual-adjustments`, { params: data }).then(res => res.data)
  },
  addManualAdjustment: data => {
    return client.post(`finance/manual-adjustments`, data).then(res => res)
  },
  getUserInfo: data => {
    return client.get(`common/users/search`, { params: data }).then(res => res.data)
  },
  getManualPaymentsById: data => {
    return client.get(`finance/manual-adjustments/${data.id}`, { params: data }).then(res => res.data)
  },
  cancelManualPayment: data => {
    return client.post(`finance/manual-adjustments/${data.id}/cancel`, data).then(res => res)
  },
  updateManualPayment: data => {
    return client.put(`finance/manual-adjustments/${data.id}`, data).then(res => res)
  },
  getFinancePublisherBillingsManualDetails: data => {
    return client.get(`finance/publisher/billings/details/${data.billingId}/manual-items`, { params: data }).then(res => res)
  },
  getFinanceSellerBillingsManualDetails: data => {
    return client.get(`finance/seller/billings/details/${data.billingId}/manual-items`, { params: data }).then(res => res)
  },
  addDeal: data => {
    return client.post(`product/deal`, data).then(res => res)
  },
  getDealList: data => {
    return client.get(`product/deal/list`, { params: data }).then(res => res)
  },
  getSellerInfo: data => {
    return client.get(`seller/amazon-connections`, { params: data }).then(res => res.data)
  },
  getAsinInfo:data=>{
    return client.get(`product/deal/asin/search`, { params: data }).then(res => res.data)
  },
  productDealExport: data => {
    return exportFile(`product/deal/export`, data.qs, data.fileName, data.platform)
  },
  associateproductDealExport: data => {
    return exportFile(`seller/associate/publisher/detail/export`, data.qs, data.fileName, data.platform)
  },
  
  productDealUpdateCsv: data => {
    return client.put(`product/deal/updateCsv`, data).then(res => res)
  },
  productSensitiveAsinList: data => {
    return client.get(`product/sensitive-asin/list`, { params: data }).then(res => res)
  },
  productSensitiveAsinDelete: data => {
    return client.delete(`product/sensitive-asin/${ data.id}`).then(res => res)
  },
  addProductSensitiveAsin: data => {
    return client.post(`product/sensitive-asin`, data).then(res => res)
  },
  downloadProductSensitiveAsinFile: (data) => {
    return exportFile(`product/sensitive-asin/download-template`, data.qs, data.fileName, data.platform)
  },
  productSensitiveUpload: data => {
    return client.post(`product/sensitive-asin/batch-upload`, data).then(res => res)
  },
  financePublisherBillingsDetailsExport: (data) => {
    return exportFile(`finance/publisher/billings/details/export`, data.qs, data.fileName, data.platform)
  },
  getFinancePublisherBillingsList: data => {
    return client.get('publisher/billings', { params: data }).then(res => res.data)
  },
  setReceivedDetails: data => {
    return client.post(`finance/seller/billings/details/received`, data).then(res => res)
  },
    // 账单支付详情
  financeSellerBillingsPayment: data => {
    return client.get(`finance/seller/billings/payment`, { params: data }).then(res => res.data)
  },
  financeSellerBillingsPaymentExport: data => {
    return exportFile(`finance/seller/billings/payment/export`, data.qs, data.fileName, data.platform)
  },
  getSensitiveProducts: data => {
    return client.get(`seller/associate/publisher/detail/page`, { params: data }).then(res => res)
  },
  dmSubmittedDealsManualCsvTemplate: data => {
    return exportFile(`dm-submitted-deals/manual/csv/template`, data.qs, data.fileName, data.platform)
  },
  dmSubmittedDealsManualCsvValidate: data => {
    return client.post(`dm-submitted-deals/manual/csv/validate`, data).then(res => res)
  },
  dmSubmittedDealsManualCsvSubmit: data => {
    return client.post(`dm-submitted-deals/manual/csv/submit`, data).then(res => res)
  },
   financePublisherAgg: data => {
        return client.get('finance/publisher/publisher-agg', { params: data }).then(res=>res);
   },
   financePublisherPublisherAggExport: data => {
        return exportFile(`finance/publisher/publisher-agg/export`, data.qs, data.fileName, data.platform);
   },
   financePublisherBillingsDetailsPaymentBrands: data => {
    return client.get(`finance/publisher/billings/details/payment-brands`, { params: data }).then(res => res)
   },
   financePublisherBillingsDetailsPaymentBrandsSetToNotPaid: data => {
    return client.post(`finance/publisher/billings/details/payment-brands/set-to-not-paid`, data).then(res => res)
   },
   financePublisherBillingsDetailsDecline: data => {
    return client.post(`finance/publisher/billings/details/decline`, data).then(res => res)
   },
   financePublisherBillingsDetailsUndoDecline: data => {
    return client.post(`finance/publisher/billings/details/undo-decline`, data).then(res => res)
   },
   getPublisherPayoutTasks: data => {
    return client.get('finance/publisher/payout-exports', { params: data }).then(res => res)
   },
   createPublisherPayoutTask: data => {
    return client.post('finance/publisher/payout-exports', data).then(res => res)
   },
   cancelPublisherPayoutTask: data => {
    return client.post(`finance/publisher/payout-exports/${data.id}/cancel`, data).then(res => res)
   },
   retryPublisherPayoutTask: data => {
    return client.post(`finance/publisher/payout-exports/${data.id}/retry`, data).then(res => res)
   },
}